import { Directive, Input, ElementRef, OnInit, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { Observe } from '../custom-decorators/Observe';
import { Observable, Subscription } from 'rxjs';


@Directive({
	selector: '[appActiveTab]'
})
export class ActiveTabDirective implements OnInit, OnDestroy, AfterViewInit {
	@Input() appActiveTab : boolean = false;
	@Observe("appActiveTab") appActiveTab$! : Observable<any>;
	private sub : Subscription;
	
	constructor(private el : ElementRef, private renderer : Renderer2) 
	{ 		
		
	}

	ngOnInit(): void {
		this.sub = this.appActiveTab$?.subscribe({
			next : (isActive : boolean) => {
				this.setSize();
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}
		});
	}


	ngOnDestroy(): void {
		this.sub && this.sub?.unsubscribe();
	}

	ngAfterViewInit(): void {
		this.setSize();
	}

	private setSize = () => {
		if(this.appActiveTab)
		{			
			const parentRect = this.el?.nativeElement?.parentElement?.getBoundingClientRect();
			if(parentRect)
			{
				this.renderer.setStyle(this.el?.nativeElement, "height", `${parentRect.height}`);
				this.renderer.setStyle(this.el?.nativeElement, "width", `${parentRect.width}`);
			}			
		}
	}
}
